module.exports = __webpack_public_path__ + "/40bb11d55aec7ca17dc1f22def0d0778.png";